<script setup lang="ts">
import { useFetchBurnHistory } from '~/api/service/livewatch/burn-history.service'
import BurnHistoryTable from '~/components/table/burn-history/BurnHistoryTable.vue'
import BcPagination from '~/ui/Pagination/BcPagination.vue'

const { pagination, rowPerPageList } = usePagination(
  {
    page: 1,
    rowPerPage: 25,
  },
  false
)

const { data, isLoading } = useFetchBurnHistory(pagination)
</script>

<template>
  <section class="flex flex-col gap-5">
    <div class="flex items-center justify-between">
      <h2 class="text-2xl font-bold text-white">Burn History</h2>
      <div class="rounded bg-explorer-green/10 px-2 py-1 text-lg font-medium text-explorer-green">
        Live Updates
      </div>
    </div>

    <Card class="overflow-hidden">
      <BurnHistoryTable
        :rows="data?.burnHistoryList || []"
        :is-loading="isLoading"
        :row-cnt="pagination.rowPerPage"
      />
      <BcPagination
        v-if="data?.VCNT"
        v-model="pagination"
        :row-per-page-list="rowPerPageList"
        :total-count="data.VCNT"
      />
    </Card>
  </section>
</template>

